export type Permission = (typeof Permissions)[number];

export const Permissions = [
  /* ----- order ----- */
  'order:read',
  'order:create',
  'order:delete',
  'order:edit',

  'order.tabs:notes',
  'order.tabs:bussiness',
  'order.tabs:install',
  'order.tabs:protocol',
  'order.tabs:complaints',
  'order.tabs:finance',

  // order note tab
  'order.notes.todo:read',
  'order.notes.todo:create',
  'order.notes.todo:delete',
  'order.notes.todo:edit',
  'order.notes.todo:set_state',

  'order.notes.note:read',
  'order.notes.note:create',
  'order.notes.note:edit',
  'order.notes.note:delete',

  // order bussiness tab
  'order.bussiness.price:read',
  'order.bussiness.price:create',
  'order.bussiness.price:delete',
  'order.bussiness.price:edit',

  'order.bussiness.document:read',
  'order.bussiness.document:create',
  'order.bussiness.document:delete',

  'order.bussiness.contract:read',
  'order.bussiness.contract:create',
  'order.bussiness.contract:edit',
  'order.bussiness.contract:delete',
  'order.bussiness.contract:sign',

  // order install tab
  // i dont think this needs finer permissions
  'order.install:read',
  'order.install:create',
  'order.install:delete',

  // order protocol tab
  'order.protocol:read',
  'order.protocol:create',
  'order.protocol:edit',
  'order.protocol:delete',

  // order complaints tab
  // honestly idk how complaints even work
  'order.complaints:read',
  'order.complaints:edit',
  'order.complaints:set_completed',
  'order.complaints:upload_attachment',
  'order.complaints:delete',

  // order finance tab
  'order.finance:read',
  'order.finance:create',
  'order.finance:edit',
  'order.finance:delete',

  // order settings
  'order.settings:read',

  /* ----- customers ----- */
  'customer:read',
  'customer:create',
  'customer:edit',
  'customer:delete',

  'customer.tabs:orders',
  'customer.tabs:notes',
  'customer.tabs:documents',

  // customer note tab
  'customer.note:read',
  'customer.note:create',
  'customer.note:edit',
  'customer.note:delete',

  // customer document tab
  'customer.document:read',
  'customer.document:create',
  'customer.document:delete',

  /* ----- partners ----- */
  'partner:read',
  'partner:create',
  'partner:edit',
  'partner:delete',

  'partner.tabs:orders',
  'partner.tabs:notes',
  'partner.tabs:documents',

  // partner note tab
  'partner.note:read',
  'partner.note:create',
  'partner.note:edit',
  'partner.note:delete',

  // partner document tab
  'partner.documents:read',
  'partner.documents:create',
  'partner.documents:delete',

  /* ----- products ----- */
  'product:read',
  'product:create',
  'product:edit',
  'product:delete',

  /* ----- work items ----- */
  'task:read',
  'task:create',
  'task:edit',
  'task:delete',

  /* ----- calendar ----- */
  'calendar:read',
  'calendar.event:edit',
  'calendar.event:create',
  'calendar.event:delete'
] as const;